import {
  CALCULATION_TYPES,
  APPLICABLE_ON,
  TAX_SCOPE,
  INCLUSIVE_TYPE,
  TAX_GROUP,
} from "../../../Constants/Tax/index";

const forms = [
  {
    name: "Basic Details",
    options: [
      {
        name: "Tax Name",
        type: "input",
        form: {
          type: "text",
          name: "name",
          placeholder: "Enter tax name",
          class: "",
          value: "",
          required: true,
        },
      },
      {
        name: "Tax Code",
        type: "input",
        form: {
          type: "text",
          name: "code",
          placeholder: "Enter tax code",
          class: "",
          value: "",
          required: true,
        },
      },
      {
        name: "Description",
        type: "input",
        form: {
          type: "text",
          name: "description",
          placeholder: "Tax description",
          class: "",
          value: "",
          required: false,
        },
      },
    ],
  },
  {
    name: "Tax Configuration",
    options: [
      {
        name: "Tax Type",
        type: "selectandadd",
        path: "/app/tax/types/add",
        form: {
          name: "taxType",
          allowClear: true,
          showSearch: true,
          filterOption: false,
          placeholder: "Select tax type",
          api: "get-all-tax-types",
          source: "TaxType",
          options: null,
          value: null,
          required: true,
        },
      },
      {
        name: "Calculation Type",
        type: "select",
        form: {
          name: "calculationType",
          allowClear: false,
          placeholder: "Select calculation type",
          value: "PERCENTAGE",
          options: CALCULATION_TYPES?.map((type) => ({
            value: type,
            label: type,
          })),
          required: true,
        },
      },
      {
        name: "Tax Rate",
        type: "input",
        form: {
          type: "number",
          name: "rate",
          placeholder: "Enter tax rate",
          class: "",
          value: "",
          required: true,
        },
      },
    ],
  },
  {
    name: "Tax Settings",
    options: [
      {
        name: "Applicable On",
        type: "select",
        form: {
          name: "applicableOn",
          allowClear: false,
          placeholder: "Select applicable on",
          value: "BOTH",
          options: APPLICABLE_ON?.map((type) => ({
            value: type,
            label: type,
          })),
          required: true,
        },
      },
      {
        name: "Tax Scope",
        type: "select",
        form: {
          name: "taxScope",
          allowClear: false,
          placeholder: "Select tax scope",
          value: "ALL",
          options: TAX_SCOPE?.map((scope) => ({
            value: scope,
            label: scope,
          })),
          required: true,
        },
      },
      {
        name: "Inclusive Type",
        type: "select",
        form: {
          name: "inclusiveType",
          allowClear: false,
          placeholder: "Select inclusive type",
          value: "EXCLUSIVE",
          options: INCLUSIVE_TYPE?.map((type) => ({
            value: type,
            label: type,
          })),
          required: true,
        },
      },
      {
        name: "Tax Group",
        type: "select",
        form: {
          name: "taxGroup",
          allowClear: false,
          placeholder: "Select tax group",
          value: "STATE",
          options: TAX_GROUP?.map((group) => ({
            value: group,
            label: group,
          })),
          required: true,
        },
      },
    ],
  },
  {
    name: "Category Settings",
    options: [
      {
        name: "Category",
        type: "selectandadd",
        path: "/app/products/categories/add",
        form: {
          name: "category",
          allowClear: true,
          showSearch: true,
          filterOption: false,
          placeholder: "Product Category",
          api: "get-all-product-categories",
          options: null,
          value: null,
          required: false,
        },
      },
    ],
  },
  {
    name: "Advanced Settings",
    options: [
      {
        name: "Is Compound Tax",
        type: "checkbox",
        form: {
          name: "isCompound",
          value: false,
          required: false,
        },
      },
      {
        name: "Depends On Tax",
        type: "select",
        form: {
          name: "dependsOnTax",
          allowClear: true,
          showSearch: true,
          filterOption: false,
          placeholder: "Select parent tax",
          api: "get-all-taxes",
          source: "Tax",
          options: null,
          value: null,
          required: false,
        },
        conditional: {
          field: "isCompound",
          value: true,
        },
      },
      {
        name: "Effective From",
        type: "date",
        form: {
          type: "text",
          name: "effectiveFrom",
          placeholder: "Effective from date",
          class: "",
          value: "",
          required: true,
        },
      },
      {
        name: "Valid Until",
        type: "date",
        form: {
          type: "text",
          name: "validUntil",
          placeholder: "Valid until date",
          class: "",
          value: "",
          required: false,
        },
      },
    ],
  },
];

export default forms;
